function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from "react";
import { withTargetMbox } from "../AdobeTarget/WithTargetMbox";
import { useAbtConfig } from "../../hooks/useAbtConfig";
import useIsABTestingEnabled from "../../hooks/useIsABTestingEnabled";
import { FOOCMask } from "../utilities/FOOCMask";
import ABTestDebugInfo from "../ABTestDebugInfo/index";
import logger, { LapelError } from "../../logger";
/**
 * @example
 * export default withABTestWrapper({
 *   name: "myComponentEnabled",
 *   abTestEndDate: "01/01/2024",
 * })(MyComponent)
 *
 * @param config Configuration options for the ABTestWrapper
 * @param config.name The name of the mbox.
 * @param config.abTestEndDate The expiration date of the test. If the
 *   remote config for this mbox has a abTestEndDate set it will take
 *   precedence of this param.
 */ var withABTestWrapper = function(config) {
    var name = config.name, _config_disableFoocMask = config.disableFoocMask, disableFoocMask = _config_disableFoocMask === void 0 ? false : _config_disableFoocMask;
    return function(Component) {
        var Result = /*#__PURE__*/ forwardRef(function(props, ref) {
            var abtConfig = useAbtConfig(name, config);
            var hideContent = !abtConfig;
            var _useMemo = _sliced_to_array(useMemo(function() {
                var p = _extends({
                    disableFoocMask: false
                }, props);
                try {
                    if (typeof abtConfig === "object" && abtConfig !== null) {
                        p = _extends({}, p, abtConfig);
                    }
                } catch (error) {
                    logger.warn(new LapelError("Error merging remote configs"));
                }
                var abTestEndDate = p.abTestEndDate;
                var expiredDate = Date.parse(abTestEndDate);
                if (Number.isNaN(expiredDate) || expiredDate < Date.now()) {
                    // Disable testing
                    return [
                        Component,
                        p
                    ];
                }
                var WrappedComponent = withTargetMbox(p)(Component);
                WrappedComponent.displayName = "withABTestWrapper";
                return [
                    WrappedComponent,
                    p
                ];
            }, [
                abtConfig,
                config
            ]), 2), ConfiguredComponent = _useMemo[0], remoteProps = _useMemo[1]; // eslint-disable-line react-hooks/exhaustive-deps
            return /*#__PURE__*/ _jsx(ABTestDebugInfo, _extends({}, props, remoteProps, {
                children: /*#__PURE__*/ _jsx(FOOCMask, {
                    hide: hideContent,
                    children: hideContent ? /*#__PURE__*/ _jsx(Component, _extends({}, props, {
                        ref: ref
                    })) : /*#__PURE__*/ _jsx(ConfiguredComponent, _extends({}, props, {
                        ref: ref
                    }))
                })
            }));
        });
        Result.displayName = "withABTestWrapper";
        return Result;
    };
};
var withABTestWrapperEnabled = function(config) {
    var withEnhancedABTestWrapper = withABTestWrapper(config);
    return function(Component) {
        var WithEnhancedABTestWrapper = withEnhancedABTestWrapper(Component);
        var Result = /*#__PURE__*/ forwardRef(function(props, ref) {
            var isABTestingEnabled = useIsABTestingEnabled();
            return isABTestingEnabled ? /*#__PURE__*/ _jsx(WithEnhancedABTestWrapper, _extends({}, props, {
                ref: ref
            })) : /*#__PURE__*/ _jsx(Component, _extends({}, props, {
                ref: ref
            }));
        });
        Result.displayName = Component.displayName || Component.name || "withABTestWrapperEnabled";
        return Result;
    };
};
export { withABTestWrapperEnabled as withABTestWrapper };

//# sourceMappingURL=WithABTestWrapper.js.map